//Components 
import HeaderComponent from "../../components/HeaderComponent";
// import NewDeliveryComponent from "../../components/NewDeliveryComponent";
import NewDeliveryComponent from "./components/newDeliveryComponent";
import SidebarComponent from "../../components/SidebarComponent";


function Delivery(){
    return (
        <>
           <HeaderComponent></HeaderComponent>
            <SidebarComponent activeMenu={['sidemenu-list  active', 'sidemenu-list', 'sidemenu-list']}></SidebarComponent>
            <NewDeliveryComponent/>
            
        </>
        
    )
}

export default Delivery;